import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';

type IncPageSaveButtonProps = {
  isLoading: boolean;
  disabled?: boolean;
};

const IncPageSaveButton = ({
  isLoading,
  disabled = false,
}: IncPageSaveButtonProps) => {
  const { t } = useTranslation();

  return (
    <LoadingButton
      type="submit"
      loading={isLoading}
      variant="contained"
      data-testid="IncPageSaveButton"
      sx={{ minWidth: 150 }}
      disabled={disabled}
    >
      {t('forms.buttons.save')}
    </LoadingButton>
  );
};
export default IncPageSaveButton;
